import { useNavigation } from 'hooks/navigation/useNavigation';

import { Navigation } from './Navigation/Navigation';
import { SalonHeading } from './SalonHeading';

import s from './ClassicHeader.module.css';

export const ClassicHeader = () => {
  const { isPackagePurchaseEnabled, renderBagButton } = useNavigation();

  return (
    <header className={s.header}>
      <Navigation />
      <SalonHeading className={s.salonHeading} />
      <div className={s.bag}>
        {isPackagePurchaseEnabled && renderBagButton('')}
      </div>
    </header>
  );
};
